import { render, staticRenderFns } from "./BaseJsonEditor.vue?vue&type=template&id=41e58a90"
import script from "./BaseJsonEditor.vue?vue&type=script&lang=js"
export * from "./BaseJsonEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports